import { useEffect, useState } from "react";

import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

import { readVoltRoles, voltAreas } from "../navigation/voltAreas";
import type { WorkshopAccess } from "../workshop/useWorkshopAccess";

/** Same rule as the menu: accounting is for superadmins; the API checks again. */
export const useAccountingAccess = (): WorkshopAccess => {
  const [access, setAccess] = useState<WorkshopAccess>("loading");
  useEffect(() => {
    // INITIAL_SESSION fires right after subscribing.
    const { data } = getSupabaseClient().auth.onAuthStateChange(
      (_event, session) => {
        const areas = voltAreas(readVoltRoles(session?.access_token));
        setAccess(areas.accounting ? "granted" : "denied");
      },
    );
    return () => data.subscription.unsubscribe();
  }, []);
  return access;
};
